import { useEffect, useState } from "react";

import moment from "moment";
import { clientDetailsApi } from "../apis/customer/customer-apis";
import errorToast from "../utils/toast/errorToast";

export default function HOAProfile() {
  const [previewIndex, setPreviewIndex] = useState(null);
  const [connected, setConnected] = useState(false);
  const [viewData, setViewData] = useState("");
  const [gallery, setGallery] = useState([]);
  const [profileView, setProfileView] = useState(false);

  const viewFnc = async () => {
    try {
      const res = await clientDetailsApi({
        id: "b4c9f8a8-721e-435d-840c-35556d8713bf",
      });
      if (res.status === 200) {
        setViewData(res.data?.data);
      }
    } catch (error) {
      errorToast("Please try again later");
    }
  };

  useEffect(() => {
    viewFnc();
  }, []);

  useEffect(() => {
    if (viewData?.customerImages?.length > 0) {
      setGallery(viewData?.customerImages);
    }
  }, [viewData]);

  const profile = {
    name: "Nipun Malhotra",
    age: 33,
    height: "5 ft. 10 inches",
    religion: "Hindu",
    caste: "Punjabi - Malhotra",
    location: "New Delhi, India",
    profession: "Business / Self Employed",
    about:
      "He is a career-oriented, grounded, and practical individual with a positive mindset. Nipun embodies a perfect blend of traditional values and a modern outlook.",
  };

  const nextImage = () => {
    setPreviewIndex((prev) => (prev + 1) % gallery.length);
  };

  const prevImage = () => {
    setPreviewIndex((prev) => (prev === 0 ? gallery.length - 1 : prev - 1));
  };

  const habitOptions = [
    {
      label: "No",
      value: "no",
    },
    {
      label: "Occasionally",
      value: "occasionally",
    },
    {
      label: "Regularly",
      value: "regularly",
    },
    {
      label: "dont want to disclose",
      value: "dont_want_to_disclose",
    },
  ];

  const dietPreferenceOptions = [
    {
      label: "Veg",
      value: "veg",
    },
    {
      label: "Non veg",
      value: "non_veg",
    },
    {
      label: "Vegan",
      value: "vegan",
    },
    {
      label: "Eggetarian",
      value: "eggetarian",
    },
    {
      label: "dont want to disclose",
      value: "dont_want_to_disclose",
    },
  ];

  const manglikStatusOptions = [
    {
      label: "Yes",
      value: "yes",
    },
    {
      label: "No",
      value: "no",
    },
    {
      label: "Partial anshik",
      value: "partial_anshik",
    },
    {
      label: "Dont know",
      value: "dont_know",
    },
  ];

  const educationType = [
    { label: "School", value: "school" },
    { label: "Bachelors", value: "bachelors" },
    { label: "Masters", value: "masters" },
    { label: "12th", value: "12th" },
    { label: "Diploma", value: "diploma" },
    { label: "PHD", value: "phd" },
  ];

  const getEducationSentence = (type, qualification) => {
    switch (type?.toLowerCase()) {
      case "school":
        return `Schooling`;

      case "12th":
        return `12th - ${qualification}`;

      case "diploma":
        return `Diploma - ${qualification}`;

      case "bachelors":
        return `Graduation - ${qualification}`;

      case "masters":
        return `Post Graduation - ${qualification}`;

      case "phd":
        return `PhD - ${qualification}`;

      default:
        return qualification;
    }
  };

  const propertyTypeOptions = [
    {
      label: "Own",
      value: "own",
    },
    {
      label: "Rented",
      value: "rented",
    },
    {
      label: "Leased",
      value: "leased",
    },
    {
      label: "Dont want to disclose",
      value: "dont_want_to_disclose",
    },
  ];

  return (
    <div className="min-h-screen bg-[#071c22] text-[#d6d6d6] relative overflow-hidden">
      {/* Background Gradients */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(16,185,129,0.15),transparent_60%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom,rgba(16,185,129,0.15),transparent_60%)]" />
      </div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 md:px-8 py-8 sm:py-10 md:py-12 space-y-8 sm:space-y-10">
        {/* HEADER */}
        <div className="bg-[#0f1e22] border border-[#123f46] rounded-2xl py-6 sm:py-8 text-center shadow-lg">
          <h1 className="text-fs_30 font-fw_500 tracking-widest text-[#caa96a] leading-snug px-4 Alata_font">
            VIP MATRIMONIAL SERVICES (P) LIMITED
          </h1>
          <h1 className="text-fs_34 font-fw_500 text-[#caa96a] Italianno_font">
            Personalized & Confidential Services
          </h1>
        </div>
        {/* ABOUT */}
        <section className="bg-[#0f1e22] border border-[#123f46] rounded-xl p-4 sm:p-6 md:p-8 shadow-lg space-y-10 transition-all duration-500 hover:shadow-2xl hover:-translate-y-1">
          <SectionHeading title="About" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-start">
            <div className="rounded-xl p-4 sm:p-5 shadow-xl bg-[#0c1a1d] border border-[#123f46]">
              <img
                src={viewData?.profile_bio_url}
                alt="Profile"
                onClick={() => setProfileView(true)}
                className="w-full h-64 sm:h-72 md:h-80 object-cover rounded-lg cursor-pointer"
              />

              <div className="text-center mt-4 text-xs sm:text-sm text-gray-300 space-y-1">
                {/* Age */}
                <p>{viewData?.age ? `${viewData.age} Years` : "--"}</p>

                {/* Marital Status */}
                <p>
                  {viewData?.marital_status
                    ? viewData.marital_status
                        .replaceAll("_", " ")
                        .replace(/\b\w/g, (c) => c.toUpperCase())
                    : "--"}
                </p>

                {/* Height */}
                <p>{viewData?.height ? `${viewData.height} ft` : "--"}</p>

                {/* Profession */}
                <p>
                  {viewData?.currentProfessionDetails?.name?.trim() || "--"}
                </p>

                {/* Health Condition */}
                <p>
                  {viewData?.health_conditions === false
                    ? "No Health Problems"
                    : viewData?.health_conditions
                      ? "Health Issues Present"
                      : "--"}
                </p>
              </div>
            </div>

            {/* Right Content */}
            <div className="md:col-span-1 lg:col-span-2 space-y-6">
              <div className="inline-block bg-[#d9d9d9] text-black px-3 py-1 text-sm sm:text-base font-medium break-words rounded-sm">
                {viewData?.name ?? "--"}
              </div>

              <p className="text-gray-300 text-sm sm:text-base leading-relaxed max-w-2xl">
                {viewData?.about_me ?? "--"}
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-xs sm:text-sm text-gray-400 pt-4">
                <div className="space-y-2">
                  <p>
                    <Gold>Country living in:</Gold>{" "}
                    {viewData?.workingCountry?.name}
                  </p>
                </div>
              </div>

              <button
                // onClick={() => setConnected(true)}
                className="mt-4 px-5 py-2 text-sm sm:text-base border border-[#caa96a] text-[#caa96a] hover:bg-[#caa96a] hover:text-black transition"
              >
                Connect Profile
              </button>
            </div>
          </div>

          {/* Bottom 3 Column Details Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pt-6 border-t border-[#123f46]">
            {/* Religious Background */}
            <div>
              <h3 className="text-[#caa96a] font-semibold text-sm sm:text-base mb-4 border-l-2 border-[#caa96a] pl-3">
                Religious Background
              </h3>
              <div className="space-y-2 text-xs sm:text-sm text-gray-400">
                <p>
                  <span className="text-gray-300">Religion</span> :{" "}
                  {viewData?.religionDetails?.name ?? "--"}
                </p>
                <p>
                  <span className="text-gray-300">Caste</span> :{" "}
                  {viewData?.casteDetails?.name ?? "--"}
                </p>

                <p>
                  <span className="text-gray-300">Gotra</span> :{" "}
                  {viewData?.gotra ?? "--"}
                </p>
              </div>
            </div>

            {/* Basics & Lifestyle */}
            <div>
              <h3 className="text-[#caa96a] font-semibold text-sm sm:text-base mb-4 border-l-2 border-[#caa96a] pl-3">
                Basics & Lifestyle
              </h3>
              <div className="space-y-2 text-xs sm:text-sm text-gray-400">
                {/* <p>
                  <span className="text-gray-300">Skin Tone</span> : Fair
                </p>
                <p>
                  <span className="text-gray-300">Body Type</span> : Slim
                </p>
                <p>
                  <span className="text-gray-300">Body Weight</span> : 68 Kg's
                </p> */}
                <p>
                  <span className="text-gray-300">Drink</span> :{" "}
                  {habitOptions?.find(
                    (item) => item?.value === viewData?.drinking_habit,
                  )?.label ?? "--"}
                </p>
                <p>
                  <span className="text-gray-300">Smoke</span> :{" "}
                  {habitOptions?.find(
                    (item) => item?.value === viewData?.smoking_habit,
                  )?.label ?? "--"}
                </p>
                <p>
                  <span className="text-gray-300">Diet</span> :{" "}
                  {dietPreferenceOptions?.find(
                    (item) => item?.value === viewData?.diet_preference,
                  )?.label ?? "--"}
                </p>
              </div>
            </div>

            {/* Astrology Details */}
            <div>
              <h3 className="text-[#caa96a] font-semibold text-sm sm:text-base mb-4 border-l-2 border-[#caa96a] pl-3">
                Astrology Details
              </h3>
              <div className="space-y-2 text-xs sm:text-sm text-gray-400">
                <p>
                  <span className="text-gray-300">Date Of Birth</span> :
                  {viewData?.date_of_birth
                    ? moment(viewData?.date_of_birth).format("DD-MMM-YYYY")
                    : "--"}
                </p>
                <p>
                  <span className="text-gray-300">Time Of Birth</span> :{" "}
                  {viewData?.date_of_birth
                    ? moment(
                        `${viewData?.date_of_birth} ${viewData?.time_of_birth}`,
                        "YYYY-MM-DD hh:mm A",
                      ).format("hh:mm A")
                    : "--"}
                </p>
                <p className="capitalize">
                  <span className="text-gray-300">Place Of Birth</span> :{" "}
                  {viewData?.place_of_birth ?? "--"}
                </p>

                <p>
                  <span className="text-gray-300">Manglik Status</span> :{" "}
                  {manglikStatusOptions?.find(
                    (item) => item?.value === viewData?.manglik_status,
                  )?.label ?? "--"}
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* PROFESSION */}
        <section className="bg-[#0f1e22] border border-[#123f46] rounded-xl p-4 sm:p-6 md:p-8 shadow-lg space-y-6 transition-all duration-500 hover:shadow-2xl hover:-translate-y-1">
          <SectionHeading title="Profession & Education" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-xs sm:text-sm text-gray-400 pt-lg-3">
            <div>
              <h3 className="text-[#caa96a] font-semibold text-sm sm:text-base mb-4 border-l-2 border-[#caa96a] pl-3">
                Education
              </h3>

              {viewData?.educationDetails?.map((item, index) => (
                <div
                  key={index}
                  className="border-b border-[#123f46] pb-4 mb-4 last:border-none"
                >
                  <p className="text-[#c5c5c5] font-semibold text-sm sm:text-base">
                    {getEducationSentence(item.type, item.qualification)}
                  </p>

                  <p className="text-[#918e8e] text-xs sm:text-sm mt-1">
                    From {item.institution}
                  </p>
                </div>
              ))}
            </div>
            <div>
              <h3 className="text-[#caa96a] mb-3">Current Occupation</h3>
              <p>Director in Manufacturing Business</p>
              <p>Actively involved in business operations for 5+ years.</p>
            </div>
          </div>
        </section>

        {/* Business Info. */}
        <section className="bg-[#0f1e22] border border-[#123f46] rounded-xl p-8 shadow-lg space-y-6 transition-all duration-500 hover:shadow-2xl hover:-translate-y-1">
          <SectionHeading title="Business Info." />

          <div className="text-sm text-gray-400 space-y-4">
            {viewData?.businessInformation?.length > 0 ? (
              viewData.businessInformation.map((business) => (
                <div
                  key={business.id}
                  className="border-b border-[#123f46] pb-4 last:border-none"
                >
                  {/* Title */}
                  <p className="text-[#caa96a] font-medium mb-1 capitalize">
                    {business.name?.replace(/([A-Z])/g, " $1")}
                  </p>

                  {/* Description */}
                  <p>{business.about}</p>
                </div>
              ))
            ) : (
              <p>No business information available.</p>
            )}
          </div>
        </section>

        {/* FAMILY */}
        <section className="bg-[#0f1e22] border border-[#123f46] rounded-xl p-4 sm:p-6 md:p-8 shadow-lg space-y-6 transition-all duration-500 hover:shadow-2xl hover:-translate-y-1">
          <SectionHeading title="Family Info." />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-xs sm:text-sm text-gray-400">
            {/* Family Details */}
            <div>
              <h3 className="text-[#caa96a] mb-3">Family Details</h3>
              <p>{viewData?.family_type || "--"}</p>
              <p>{viewData?.family_location || "--"}</p>
              <p>{viewData?.family_status || "--"}</p>
            </div>

            {/* Parents */}
            <div>
              <h3 className="text-[#caa96a] mb-3">Parents</h3>

              {/* Father */}
              {viewData?.father_name && (
                <div className="mb-4">
                  <span className="inline-block bg-gray-200 text-black text-[10px] px-2 py-1 rounded mb-2">
                    Father
                  </span>

                  <p className="text-white font-medium">
                    Mr. {viewData?.father_name}
                  </p>

                  <p>{viewData?.fatherProfession?.name || "--"}</p>

                  <p className="mt-1">{viewData?.father_about}</p>
                </div>
              )}

              {/* Mother (if available) */}
              {viewData?.mother_name && (
                <div>
                  <span className="inline-block bg-gray-200 text-black text-[10px] px-2 py-1 rounded mb-2">
                    Mother
                  </span>

                  <p className="text-white font-medium">
                    Mrs. {viewData?.mother_name}
                  </p>

                  <p>{viewData?.motherProfession?.name || "--"}</p>

                  <p className="mt-1">{viewData?.mother_about}</p>
                </div>
              )}
            </div>

            {/* Siblings */}
            <div>
              <h3 className="text-[#caa96a] mb-3">Siblings</h3>

              {viewData?.siblings?.length > 0 ? (
                viewData?.siblings?.map((sibling) => (
                  <div key={sibling.id} className="mb-5">
                    {/* Tag like image (Married Sister / Brother etc) */}
                    <span className="inline-block bg-gray-200 text-black text-[10px] px-2 py-1 rounded mb-2 capitalize">
                      {sibling.marital_status?.replace("_", " ")}{" "}
                      {sibling.gender === "male" ? "Brother" : "Sister"}
                    </span>

                    {/* Name */}
                    <p className="text-white font-medium">{sibling.name}</p>

                    {/* Age + Marital Status */}
                    <p>
                      Age {sibling.age} |{" "}
                      <span className="capitalize">
                        {sibling.marital_status?.replace("_", " ")}
                      </span>
                    </p>

                    {/* About */}
                    <p className="mt-1">{sibling.about}</p>
                  </div>
                ))
              ) : (
                <p>No sibling information available.</p>
              )}
            </div>
          </div>
        </section>

        {/* Residence */}
        <section className="bg-[#0f1e22] border border-[#123f46] rounded-xl p-8 shadow-lg space-y-6 transition-all duration-500 hover:shadow-2xl hover:-translate-y-1">
          <SectionHeading title="Residence" />

          <div className="grid md:grid-cols-2 gap-8 text-sm text-gray-400">
            {/* Parents Permanent Residence */}
            <div>
              <h3 className="text-[#caa96a] mb-3">Permanent Residence</h3>

              <p>{viewData?.parents_permanent_address || "--"}</p>

              <p>
                {viewData?.parents_home_size
                  ? `${viewData.parents_home_size} sq yards`
                  : "--"}
              </p>
              {viewData?.parents_property_type !== "dont_want_to_disclose" && (
                <p>
                  House Living in :{" "}
                  {
                    propertyTypeOptions?.find(
                      (item) => item?.value === viewData?.parents_property_type,
                    )?.label
                  }
                </p>
              )}
            </div>

            {/* Candidate Residence (Only if different) */}
            {viewData?.candidate_address_different && (
              <div>
                <h3 className="text-[#caa96a] mb-3">Other Residence</h3>

                <p>{viewData?.candidate_address || "--"}</p>

                <p>
                  {viewData?.candidate_home_size
                    ? `${viewData.candidate_home_size} sq yards`
                    : "--"}
                </p>

                <p>
                  {viewData?.candidate_property_type === "own"
                    ? "Self-Owned House"
                    : viewData?.candidate_property_type || "--"}
                </p>
              </div>
            )}
          </div>
        </section>

        {/* PHOTOS */}
        <section className="bg-[#0f1e22] border border-[#123f46] rounded-xl p-4 sm:p-6 md:p-8 shadow-lg space-y-6 transition-all duration-500 hover:shadow-2xl hover:-translate-y-1">
          <SectionHeading title="Photos" />

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
            {gallery.map((img, index) => (
              <img
                key={index}
                src={img?.image_url}
                alt="Gallery"
                onClick={() => setPreviewIndex(index)}
                className="w-full h-32 sm:h-36 md:h-40 object-cover rounded-lg cursor-pointer hover:opacity-80 transition"
              />
            ))}
          </div>
        </section>
      </div>

      {/* IMAGE MODAL */}
      {previewIndex !== null && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50">
          <button
            onClick={() => setPreviewIndex(null)}
            className="absolute top-4 right-4 sm:top-6 sm:right-6 text-white text-2xl sm:text-3xl"
          >
            ×
          </button>

          <button
            onClick={prevImage}
            className="absolute left-2 sm:left-6 text-white text-3xl sm:text-4xl"
          >
            ‹
          </button>

          <img
            src={gallery[previewIndex]?.image_url}
            alt="Preview"
            className="max-h-[80vh] max-w-[80vw] w-full object-contain rounded-lg"
            style={{ imageRendering: "auto" }}
          />

          <button
            onClick={nextImage}
            className="absolute right-2 sm:right-6 text-white text-3xl sm:text-4xl"
          >
            ›
          </button>
        </div>
      )}

      {profileView && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50">
          <button
            onClick={() => setProfileView(false)}
            className="absolute top-4 right-4 sm:top-6 sm:right-6 text-white text-2xl sm:text-3xl"
          >
            ×
          </button>

          <img
            src={viewData?.profile_bio_url}
            alt="Preview"
            className="max-h-[80vh] max-w-[80vw] w-full object-contain rounded-lg"
          />
        </div>
      )}
    </div>
  );
}

function SectionHeading({ title }) {
  return (
    <div className="relative">
      <div className="absolute -left-3 sm:-left-4 top-2 sm:top-3 h-8 sm:h-12 w-1 bg-[#caa96a]" />
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#2f4f55] opacity-80 tracking-wide">
        {title}
      </h2>
    </div>
  );
}

function Gold({ children }) {
  return <span className="text-[#caa96a]">{children}</span>;
}
